export const paths = {
	index: "/",
	agents: {
		list: "/agents",
		create: "/agents/create",
	},
	clients: {
		list: "/clients",
		create: "/clients/create",
	},
	products: {
		list: "/products?tab=types",
		create: "/products/create",
	},
	reports: `/reports?reportsTab=summary&from=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()}&to=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 0, 0).toISOString()}`,
	settings: "/settings",
	fixDiscounts: "/fix-discount",
	accountTransactions: "/account-transactions?accountsTab=accounts",
	additionalFees: "/additional-fee",
	fileHistory: `/file-history?from=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()}&to=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 0, 0).toISOString()}&page=1&limit=20`,
	fiancances: `/finances?financesTab=monthly-statement&from=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()}&to=${new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 0, 0).toISOString()}`,
	auth: {
		login: "/login",
	},
	notAuthorized: "/401",
	notFound: "/404",
	serverError: "/500",
};
